module.exports = __webpack_public_path__ + "920d74c2acd42c1605c3158549de43ea.png";